export const LEGAL_DOCUMENTS = Object.freeze({
  terms: { title: "Términos y Condiciones", path: "/terminos.html" },
  privacy: { title: "Aviso de Privacidad", path: "/privacidad.html" },
  ugc: { title: "Política UGC", path: "/ugc.html" },
});

export const LEGAL_DOCUMENT_ORDER = Object.freeze(["privacy", "ugc", "terms"]);

const LEGAL_PATH_ALIASES = Object.freeze({
  "/terminos.html": "terms",
  "/privacidad.html": "privacy",
  "/aviso-privacidad.html": "privacy",
  "/ugc.html": "ugc",
  "/politica-ugc.html": "ugc",
});

export const getLegalDocumentKey = (href) => {
  if (!href) return null;
  try {
    return LEGAL_PATH_ALIASES[new URL(href, window.location.origin).pathname] || null;
  } catch {
    return null;
  }
};
